import React, { useState, useEffect } from "react";
import _ from "lodash";
import Socket from "socket";
import { motion } from "framer-motion/dist/framer-motion";

import TriviaSubmit from "assets/images/sbs/TriviaSubmit.png";

const Question = ({
  users,
  player,
  roomId,
  playAudio,
  mobile_app,
  questionObj,
  select_sound,
  question_params
}) => {
  const [answeredCount, setAnsweredCount] = useState(0);

  const asker_label = _.get(
    question_params,
    "asker_label",
    "You're the Asker!"
  );
  const click_below = _.get(
    question_params,
    "click_below",
    "Click below to score"
  );
  const guessed_button = _.get(
    question_params,
    "guessed_button",
    "Everyone has guessed!"
  );

  const divVariants = {
    hidden: {},
    visible: {},
    exit: {}
  };
  const buttonVariants = {
    hidden: { x: "100vw" },
    visible: { x: 0 },
    exit: { x: "-100vw" }
  };
  const textVariants = {
    hidden: { opacity: 0.4, scale: 0.2 },
    visible: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.2 }
  };
  const questionTextVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { delay: 0.5 } },
    exit: { x: "-100vw" }
  };
  const scrollDivVariants = {
    hidden: { x: "100vw" },
    visible: { x: 0 },
    exit: { x: "-100vw", transition: { delay: 0.4 } }
  };

  useEffect(() => {
    let count = 0;
    player.forEach((player) => player.answer_time && count++);
    setAnsweredCount(count);
  }, [player]);

  const handleSubmit = () => {
    playAudio(select_sound);
    if (mobile_app) {
      const message = {
        action: "update-status"
      };
      window.parent.postMessage(message, "*");
    } else {
      const data = {
        action: "update-status",
        roomId: roomId
      };
      Socket.sendMessage(data);
    }
  };

  return (
    <div className="container">
      <motion.div
        variants={divVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        className="Lightning-trivia-Wrapper SubmitTrivia-questionAnswer asked-question TriviaScore"
      >
        <img src={TriviaSubmit} className="logoimage" alt="sbsLogo" />
        <motion.div
          variants={scrollDivVariants}
          className={`${mobile_app ? "overflowAskerMobile" : "overflowAsker"}`}
        >
          <div className="question-wrapper">
            <motion.h2
              variants={textVariants}
              className="mediamText whiteText shdjsb"
            >
              {asker_label}
            </motion.h2>
            <motion.div
              variants={buttonVariants}
              className="questionArea mediamText darkBlueText questionText"
            >
              <motion.p variants={questionTextVariants}>
                {questionObj?.question}
              </motion.p>
            </motion.div>
            <motion.p variants={textVariants} className="mediamText blueText">
              Answers:
            </motion.p>
            <div className="inputWrapper">
              {questionObj?.answers.map((answer, index) => (
                <div key={index} className="selectAnswer-wrapper">
                  <motion.div
                    variants={buttonVariants}
                    transition={{ delay: (index + 1) / 10 }}
                    className={`GiovanniInput mediamText darkBlueText ${
                      questionObj.correct_answer === index && "ActiveBorder"
                    }`}
                  >
                    {answer}
                  </motion.div>
                </div>
              ))}
            </div>
            <motion.p
              variants={textVariants}
              className="mediamText blueText m-0  belowScore "
            >
              {click_below}
            </motion.p>
          </div>
        </motion.div>
        <motion.button
          type="submit"
          variants={buttonVariants}
          className="sbsButton"
          onClick={handleSubmit}
        >
          {guessed_button} ({answeredCount}/{users.length - 1})
        </motion.button>
      </motion.div>
    </div>
  );
};

export default Question;
